<template>
    <div>
        <app-sub-title text="Asignación de consignas" />
        <div class="card">
            <div class="card-body">
                <app-form-select-input
                    label="Cliente"
                    :options="clients"
                    v-model="assignment.clientId"
                    :hasError="$v.assignment.clientId.$error"
                    errorMessage="Debe seleccionar el cliente"
                    @change="$v.assignment.clientId.$touch()"
                />
            </div>
        </div>
        <app-assignment-duties-list
            :data="data"
            :on-change-page="onChangePage"
            :to-assign="toAssign"
            :unassign="unassign"
            :selected-client="assignment.clientId"
        />
    </div>
</template>

<script>
import AssignmentDutiesList from "./AssignmentDutiesList/AssignmentDutiesList.vue";
import FormSelectInput from "../../../UI/Controls/Forms/FormSelectInput.vue";
import dutiesRepository from "../../../../repositories/duties.repository.js";
import { required } from "vuelidate/lib/validators";
import { mapGetters } from "vuex";

export default {
    components: {
        appFormSelectInput: FormSelectInput,
        appAssignmentDutiesList: AssignmentDutiesList
    },
    data() {
        return {
            assignment: {
                clientId: "",
                dutyId: ""
            },
            data: {},
            page: 1
        };
    },

    validations: {
        assignment: {
            clientId: { required },
            dutyId: { required }
        }
    },

    watch: {
        "assignment.clientId"(val) {
            this.loadDuties;
        }
    },
    computed: {
        ...mapGetters(["clients"])
    },
    methods: {
        loadDuties() {
            const dr = Object.assign({}, dutiesRepository);
            dr.loadAllDuties(this.page)
                .then(data => (this.data = data))
                .catch(error => toastr.error("Error al cargar consignas"));
        },
        onChangePage(page) {
            this.page = page;
            this.loadDuties();
        },
        toAssign(duty) {
            this.assignment.dutyId = duty.id;
            const dr = Object.assign({}, dutiesRepository);
            dr.assignClient(this.assignment)
                .then(data => {
                    if (data.status) {
                        toastr.success(data.msg);
                        this.loadDuties();
                    }
                })
                .catch(error => {
                    toastr.error("Error al asignar consigna con el cliente");
                });
        },
        unassign(duty) {
            const formData = new FormData();

            formData.append("clientId", this.assignment.clientId);
            formData.append("dutyId", duty.id);
            const dr = Object.assign({}, dutiesRepository);
            dr.unassignClient(formData)
                .then(data => {
                    if (data.status) {
                        toastr.success(data.msg);
                        this.loadDuties();
                    }
                })
                .catch(error => {
                    toastr.error("Error al desasignar consigna con el cliente");
                });
        }
    },

    created() {
        this.load("clients");
        this.loadDuties();
    }
};
</script>
